import requestApi from "@/utils/requestApi";

export default {
  data() {
    return {
      list: [],
      memberInfo: {},
      orderId: "",
      pageSize: 10,
      pageNum: 1,

      totalPage: 0,
      pageTotal: 0,

      paymentTimeStart: "",
      paymentTimeEnd: "",

      searchOrderId: "",
      searchPaymentTime: [],
    };
  },
  created() {
    this.getMemberInfo();
    this.getMyPaymentDetail();
  },
  watch: {
    searchPaymentTime(date) {
      if (date && date.length) {
        this.paymentTimeStart = date[0];
        this.paymentTimeEnd = date[1];
      } else {
        this.paymentTimeStart = "";
        this.paymentTimeEnd = "";
      }
    },
  },
  methods: {
    /* 搜索 */
    searchReset() {
      this.searchOrderId = "";
      this.searchPaymentTime = [];
    },
    searchConfirm() {
      this.pageNum = 1;

      const { searchOrderId } = this;
      this.orderId = searchOrderId;

      this.getMyPaymentDetail();
    },

    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2) {
        return "row";
      }
      return "row stripe";
    },
    getMemberInfo() {
      requestApi.post(`${process.env.VUE_APP_APITAAS}scbasic/member/info/getMemberPaymentAccount`, {}).then((res) => {
        this.memberInfo = res.data;
      });
    },

    updateMyPaymentAccount(isCom) {
      if (isCom == this.memberInfo.isCom) {
        return;
      }
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}scbasic/member/info/editMyPaymentAccount`, {
          isCom: isCom,
        })
        .then((res) => {
          if (res.code == "0") {
            this.$message.success("切换成功");
            this.getMemberInfo();
          } else {
            this.$message.error(res.msg);
          }
        });
    },

    getMyPaymentDetail() {
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/payment/paymentrecord/selMyPaymentDetail`, {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          orderId: this.orderId,
          paymentTimeStart: this.paymentTimeStart,
          paymentTimeEnd: this.paymentTimeEnd,
        })
        .then((res) => {
          this.list = res.data.list;
          this.pageTotal = res.data.total;
          this.totalPage = res.data.pages;
        });
    },

    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getMyPaymentDetail();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.getMyPaymentDetail();
    },
  },
};
